import { TableFilterState } from '@/components/data-table/filters-v2';

import { TIME_OFF_QUERY_KEY_ROOT } from './time-offs-query-keys';

// Rooted under TIME_OFF_QUERY_KEY_ROOT so `invalidateTimeOffQueries` (which
// invalidates the whole root) also refreshes the approvals list after a review.
export const TIME_OFF_REQUESTS_TO_REVIEW_QUERY_KEY = [
  TIME_OFF_QUERY_KEY_ROOT,
  'requests-to-review',
];

export const getTimeOffRequestsToReviewQueryKey = (filters: TableFilterState) => [
  ...TIME_OFF_REQUESTS_TO_REVIEW_QUERY_KEY,
  filters,
];
